import { gql } from "@apollo/client";

export const UNLINK_ACCOUNT = gql`
  mutation UnlinkAccount($accountType: String) {
    unlinkAccount(accountType: $accountType)
  }
`;
